import { Breadcrumbs } from '@monorepo/shared/componentsV2/Breadcrumbs';
import { Button } from '@monorepo/shared/componentsV2/Button';
import { Header } from '@monorepo/shared/componentsV2/Header';
import { WorkflowResponse } from 'mapistry-shared';
import React, { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';
import styled from 'styled-components';
import { RouteEditMode } from '../types';

const StyledHeader = styled(Header)`
  background-color: ${({ theme }) => theme.colors.blue04};
`;

const StyledBreadcrumbs = styled(Breadcrumbs)`
  padding: 0;
` as typeof Breadcrumbs;

export function WorkflowDetailsHeader({
  workflow,
}: {
  workflow: WorkflowResponse;
}) {
  const navigate = useNavigate();
  const crumbs = useMemo(
    () => [
      { label: 'Workflows', to: './..' },
      { label: workflow.name || 'Unnamed workflow', to: '.' },
    ],
    [workflow.name],
  );
  const editWorkflowOnClick = useCallback(() => {
    navigate(`./${RouteEditMode.EDIT}`);
  }, [navigate]);

  return (
    <StyledHeader
      title={<StyledBreadcrumbs crumbs={crumbs} />}
      variant="noDropShadow"
      rightActions={
        <Button
          color="primary"
          variant="contained"
          onClick={editWorkflowOnClick}
        >
          Edit Workflow
        </Button>
      }
    />
  );
}
